import React from "react";
import { withTranslation } from "react-i18next";
import { GOOGLE_CAPTCHA_KEY, S3 } from "../constants";
import BackArrowButton from "../parts/back-arrow-button";
import submit from "submit-form";
import ReCAPTCHA from "react-google-recaptcha";
import SignupStepMarkerOrganization from "../parts/signup-step-marker-organization";
import LogoOverlayComponent from "./dashboard/settings/LogoOverlayComponent";
import MobilePreviewComponent from "./dashboard/settings/MobilePreviewComponent";
import LoginWrapper from "./LoginWrapper";
import OnboardingHeader from "./onboarding/OnboardingHeader";
import SvgIcon from "../parts/SvgIcon";
import { SignupTextInput } from "../parts/inputs/SignupTextInput";
import Select from "../parts/inputs/select";
import OnboardingRadio from "../parts/inputs/onboarding-radio";

const stepNumber = { profile: 1, preferences: 2, resume: 3 };

const getStepPhrase = (t) => ({
  profile: t("signupCoachOrg.profile"),
  preferences: t("signupCoachOrg.preferences"),
  resume: t("signupCoachOrg.resume"),
});
const getStepTitle = (t) => ({
  profile: t("signupCoachOrg.signUp"),
  preferences: t("signupCoachOrg.preferences"),
  resume: t("signupCoachOrg.resume"),
});
const getDayOptions = (t) => [
  { text: t("signupCoachOrg.daySunday"), value: 0 },
  { text: t("signupCoachOrg.dayMonday"), value: 1 },
  { text: t("signupCoachOrg.dayTuesday"), value: 2 },
  { text: t("signupCoachOrg.dayWednesday"), value: 3 },
  { text: t("signupCoachOrg.dayThursday"), value: 4 },
  { text: t("signupCoachOrg.dayFriday"), value: 5 },
  { text: t("signupCoachOrg.daySaturday"), value: 6 },
];

class View extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: "profile",
      first_name: "",
      last_name: "",
      password: "",
      confirmPassword: "",
      agreeTOS: false,
      avatar: "",
      units: "metric",
      startingCalendarDay: 0,
      errors: "",
      validCaptcha: false,
      viewportWidth: null,
      recaptchaTheme: "dark",
    };
    this.selectFile = this.selectFile.bind(this);
    this.handleAvatarChange = this.handleAvatarChange.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.handleReturnButton = this.handleReturnButton.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleMetricsInput = this.handleMetricsInput.bind(this);
    this.handleSwitch = this.handleSwitch.bind(this);
    this.handleDaySelect = this.handleDaySelect.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.handleCaptcha = this.handleCaptcha.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  selectFile(e, edit) {
    e.preventDefault();
    if (this.state.avatar === "" || edit) {
      document.getElementById("avatar-input").click();
    } else
      this.setState(
        (prevState) => Object.assign({}, prevState, { avatar: "" }),
        () => {
          document.getElementById("avatar-input").value = "";
        }
      );
  }
  handleAvatarChange(e) {
    e.persist();
    if (typeof e.target.files[0] === "object") {
      this.setState(
        (prevState) =>
          Object.assign({}, prevState, { avatar: e.target.files[0] }),
        () => {
          const reader = new FileReader();
          const img = document.getElementById("avatar");
          reader.onload = (event) => (img.src = event.target.result);
          reader.readAsDataURL(e.target.files[0]);
        }
      );
    }
  }
  handleReturnButton() {
    if (this.state.step === "profile") {
      const url = `/login-new-onboarding/redirect/0`;
      submit(url, {
        method: "GET",
      });
    } else {
      this.setState((prevState) =>
        Object.assign({}, prevState, { step: "profile" })
      );
    }
  }

  nextStep(e) {
    e.preventDefault();
    const validation = this.validateForm("profile");
    if (validation === "success") {
      if (this.state.step === "profile") {
        return this.setState((prevState) =>
          Object.assign({}, prevState, { step: "preferences", errors: "" })
        );
      }
      if (this.state.step === "preferences") {
        return this.setState((prevState) =>
          Object.assign({}, prevState, { step: "resume", errors: "" })
        );
      }
    } else
      return this.setState((prevState) =>
        Object.assign({}, prevState, {
          errors: validation,
        })
      );
  }

  validateForm(step) {
    const { t } = this.props;
    if (step === "profile") {
      if (this.state.first_name.length <= 1)
        return { first_name: t("signupCoachOrg.errorFirstName") };
      if (this.state.last_name.length <= 1)
        return { last_name: t("signupCoachOrg.errorLastName") };
      if (this.state.password.length <= 5)
        return { password: t("signupCoachOrg.errorPasswordLength") };
      if (this.state.confirmPassword !== this.state.password)
        return { confirmPassword: t("signupCoachOrg.errorPasswordsMatch") };
      if (!this.state.agreeTOS)
        return { agreeTOS: t("signupCoachOrg.errorAgreeTOS") };
      if (!this.state.validCaptcha) {
        return { recaptcha: t("signupCoachOrg.errorRecaptcha") };
      }
      return "success";
    }
  }

  handleInputChange(e) {
    e.persist();
    this.setState((prevState) =>
      Object.assign({}, prevState, { [e.target.name]: e.target.value })
    );
  }

  handleMetricsInput(unit) {
    if (unit === this.state.units) return;
    if (unit === "metric") {
      this.setState((prevState) =>
        Object.assign({}, prevState, { units: "metric" })
      );
    } else if (unit === "imperial") {
      this.setState((prevState) =>
        Object.assign({}, prevState, { units: "imperial" })
      );
    }
  }

  updateDimensions() {
    this.setState((prevState) =>
      Object.assign({}, prevState, {
        viewportWidth: window.innerWidth,
      })
    );
  }

  componentDidMount() {
    !this.state.viewportWidth &&
      this.setState((prevState) =>
        Object.assign({}, prevState, {
          viewportWidth: window.innerWidth,
        })
      );
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  handleSwitch(switchOption) {
    if (switchOption === "agreeTOS")
      return this.setState(
        (prevState) =>
          Object.assign({}, prevState, { agreeTOS: !prevState.agreeTOS }),
        () =>
          (document.getElementById("agreeTOS-checkbox").checked =
            this.state.agreeTOS)
      );
  }

  handleDaySelect(value) {
    return this.setState((prevState) =>
      Object.assign({}, prevState, {
        startingCalendarDay: value,
      })
    );
  }

  handleCaptcha(value) {
    const finalValue = !!value;
    this.setState((prevState) =>
      Object.assign({}, prevState, {
        validCaptcha: finalValue,
      })
    );
  }

  render() {
    const {
      branding,
      userPermissions,
      userRole,
      organizationName,
      pushAccountInfo,
    } = this.props;

    const {
      splashOverlayOpacity,
      splashOverlayColor,
      mobileSplashImg,
      tintSplashImg,
      mobileSplashBg,
      appTheme,
      appMainColor,
      appColorsDefault,
      appSecondaryTextColor,
    } = branding;

    const { t } = this.props;
    const roleText = userRole === "Admin" ? `an ${userRole}` : `a ${userRole}`;

    return (
      <LoginWrapper
        mainClass="Onboarding"
        left={
          <>
            <SignupStepMarkerOrganization
              onBack={this.handleReturnButton}
              active={stepNumber[this.state.step]}
              phrase={getStepPhrase(t)[this.state.step]}
              title={getStepTitle(t)[this.state.step]}
            />

            <form method="POST" data-noreset encType="multipart/form-data">
              {/* init of hidden input to know if owner user is pull */}
              <input
                id="pushAccountInfo"
                className="pushAccountInfo"
                type="hidden"
                name="pushAccountInfo"
                defaultValue={pushAccountInfo}
              />
              {/* end of hidden input */}

              <section
                className={this.state.step === "profile" ? "" : "hidden!"}
              >
                <div
                  onClick={(e) => this.selectFile(e, true)}
                  className="avatar-wrapper"
                >
                  <div className="upload-icon-wrapper">
                    <div className="upload-icon"></div>
                  </div>
                  {this.state.avatar !== "" && (
                    <div
                      className="upload-icon-wrapper remove-wrapper"
                      onClick={(e) => this.selectFile(e, false)}
                    >
                      <div className="remove-icon"></div>
                    </div>
                  )}
                  {this.state.avatar === "" ? (
                    <SvgIcon src="/img/new-icons/vuesax-linear-user.svg" />
                  ) : (
                    <img id="avatar" className="avatar" src={""} />
                  )}
                </div>

                <input
                  id="avatar-input"
                  className="hidden"
                  type="file"
                  name="avatar"
                  placeholder={t("signupCoachOrg.addProfilePicture")}
                  accept="image/*"
                  onChange={(e) => this.handleAvatarChange(e)}
                />
              </section>

              <section
                className={this.state.step === "profile" ? "" : "hidden!"}
              >
                <SignupTextInput
                  label={t("signupCoachOrg.firstName")}
                  name={"first_name"}
                  required={true}
                  type={"text"}
                  placeholder={t("signupCoachOrg.firstName")}
                  defaultValue={this.state.first_name}
                  onChange={this.handleInputChange}
                  hasError={!!this.state.errors.first_name}
                  error={this.state.errors.first_name}
                />
                <SignupTextInput
                  label={t("signupCoachOrg.lastName")}
                  name={"last_name"}
                  required={true}
                  type={"text"}
                  placeholder={t("signupCoachOrg.lastName")}
                  defaultValue={this.state.last_name}
                  onChange={this.handleInputChange}
                  hasError={!!this.state.errors.last_name}
                  error={this.state.errors.last_name}
                />
                <SignupTextInput
                  label={t("signupCoachOrg.password")}
                  name={"password"}
                  required={true}
                  type={"password"}
                  placeholder={t("signupCoachOrg.password")}
                  defaultValue={this.state.password}
                  onChange={this.handleInputChange}
                  hasError={!!this.state.errors.password}
                  error={this.state.errors.password}
                />

                <SignupTextInput
                  name={"confirmPassword"}
                  label={t("signupCoachOrg.confirmPassword")}
                  required={true}
                  type={"password"}
                  placeholder={t("signupCoachOrg.confirmPassword")}
                  defaultValue={this.state.confirmPassword}
                  onChange={this.handleInputChange}
                  hasError={!!this.state.errors.confirmPassword}
                  error={this.state.errors.confirmPassword}
                />

                <div className="relative">
                  <label className="checkbox-input" htmlFor="agreeTOS-checkbox">
                    <input
                      id="agreeTOS-checkbox"
                      type="checkbox"
                      name="agreeTOS"
                      onChange={() => this.handleSwitch("agreeTOS")}
                      value={this.state.agreeTOS ? "on" : "off"}
                      checked={this.state.agreeTOS}
                      data-has-error={!!this.state.errors.agreeTOS}
                    />
                    {t("signupCoachOrg.agreeTerms")}{" "}
                    <a
                      href="https://mystrengthbook.com/terms-of-use/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("signupCoachOrg.termsOfUse")}
                    </a>
                  </label>
                  {this.state.errors.agreeTOS ? (
                    <p className="error">{this.state.errors.agreeTOS}</p>
                  ) : null}
                </div>
                <div role="recaptcha-wrapper" className="relative">
                  <ReCAPTCHA
                    sitekey={GOOGLE_CAPTCHA_KEY}
                    onChange={this.handleCaptcha}
                    theme={this.state.recaptchaTheme}
                    size="normal"
                  />

                  {this.state.errors.recaptcha ? (
                    <p className="error">{this.state.errors.recaptcha}</p>
                  ) : null}
                </div>
              </section>

              <div
                className={`${
                  this.state.step === "preferences"
                    ? "org-preferences"
                    : "hidden!"
                }`}
              >
                <OnboardingRadio
                  label={t("signupCoachOrg.preferredMeasurement")}
                  name="units"
                  onClick={this.handleMetricsInput}
                  options={[
                    {
                      value: "metric",
                      label: t("signupCoachOrg.metricKg"),
                      defaultChecked: true,
                    },
                    {
                      value: "imperial",
                      label: t("signupCoachOrg.imperialLbs"),
                    },
                  ]}
                  value={this.state.units}
                />

                <div className="radio-container">
                  <label htmlFor="startingCalendarDay">
                    {t("signupCoachOrg.firstDayOfWeek")}
                  </label>

                  <div>
                    <Select
                      name="startingCalendarDay"
                      options={getDayOptions(t)}
                      value={this.state.startingCalendarDay}
                      onChange={this.handleDaySelect}
                    />
                    <picture className="only-show-mobile">
                      <img src="/img/svg/angle-down.svg" />
                    </picture>
                  </div>
                </div>
              </div>

              <div
                className={`${
                  this.state.step === "resume" ? "resume" : "hidden!"
                }`}
              >
                <header role="resume-header">
                  <h2>{organizationName}</h2>
                  <h4>{t("signupCoachOrg.invitedAs", { role: roleText })}</h4>
                </header>

                <p className="p4">{t("signupCoachOrg.yourPermissions")}</p>
                <ul className="permissions">
                  {userPermissions.map((item) => {
                    const { _id, permission } = item;
                    const permissionFormat =
                      permission === "PUSH"
                        ? t("signupCoachOrg.pushSubscriptions")
                        : permission === "PRESS"
                          ? t("signupCoachOrg.pressGymManagement")
                          : permission;
                    return (
                      <li key={_id}>
                        <SvgIcon
                          src={"/img/new-icons/checked-square.svg"}
                          noFilterOnLight={true}
                        />{" "}
                        {permissionFormat}
                      </li>
                    );
                  })}
                </ul>
              </div>

              <footer>
                <button
                  data-button-type="primary"
                  onClick={(e) => {
                    if (this.state.step !== "resume") this.nextStep(e);
                  }}
                  type={this.state.step === "profile" ? "button" : "submit"}
                  sz="large"
                >
                  {t("signupCoachOrg.continue")}
                </button>

                <a href="/login" data-button-type="text-white">
                  {t("signupCoachOrg.backToLogin")}
                </a>
              </footer>
            </form>
          </>
        }
        right={
          this.state.step === "resume" ? (
            <div className="tempate-mobile-login main-phone-template-login">
              <div className="phone-template phone-template-login phone-template-login-position">
                <div
                  className="background-container"
                  style={{
                    backgroundImage:
                      mobileSplashBg && mobileSplashBg.s3Path
                        ? `url(${S3.PATH}${mobileSplashBg.s3Path})`
                        : "var(--black)",
                    backgroundColor: "var(--black)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <LogoOverlayComponent
                    opacity={splashOverlayOpacity}
                    overlayColor={splashOverlayColor}
                    withOverlay={!!splashOverlayColor}
                    withLogo
                    logo={mobileSplashImg}
                    isTinted={tintSplashImg || false}
                  />
                </div>
                <img alt="phone" src="/img/iphone-template.webp" />
              </div>
              <div className="phone-template phone-template-login">
                <div className="background-container">
                  <MobilePreviewComponent
                    theme={appTheme}
                    brandingColor={appMainColor}
                    isDefaultColor={appColorsDefault || ""}
                    secondaryTextColor={appSecondaryTextColor}
                  />
                </div>
                <img alt="phone" src="/img/iphone-template.webp" />
              </div>
            </div>
          ) : null
        }
      />
    );
  }
}

const ViewWithTranslation = withTranslation("auth")(View);

const SignupCoachOrganization = (app) => {
  app
    .get(
      "/signup-coach-organization",
      async ({ res, isLoggedIn, flash, api, req }) => {
        if (isLoggedIn()) {
          flash("error", "Please log out before trying to sign up");
          return res.redirect("/dashboard");
        }
        const { query } = req;
        const { email } = query;
        const result = await (
          await api(`organization-owner-login/${email}`, {
            method: "GET",
          })
        ).json();

        const branding = result?.activeOwnerOrganization?.customBranding;
        const userPermissions = result?.userPermissions;
        const userRole = result?.userRole;
        const pushAccountInfo =
          result?.activeOwnerOrganization.pushAccountInfo || undefined;
        const organizationName =
          result?.activeOwnerOrganization?.businessName ||
          result?.activeOwnerOrganization?.name;

        return (res.body = (
          <ViewWithTranslation
            flash={flash}
            branding={branding}
            userPermissions={userPermissions}
            userRole={userRole}
            organizationName={organizationName}
            pushAccountInfo={pushAccountInfo}
          />
        ));
      }
    )

    .post(
      "/signup-coach-organization",
      async ({ req, res, api, flash, assert, login }) => {
        const { body, files, query } = req;
        const { email } = query;
        const isPushAccountInfo = body.pushAccountInfo;
        assert(email, 400, "An email is required");
        assert(body.first_name, 400, "A first name is required");
        assert(body.last_name, 400, "A last name is required");
        assert(body.password, 400, "A password is required");
        assert(body.confirmPassword, 400, "Password confirmation is required");
        assert(
          body.confirmPassword === body.password,
          400,
          "Passwords must match"
        );
        assert(
          body.agreeTOS,
          400,
          "You must agree to the Terms and Conditions to continue"
        );

        body.name = `${body.first_name} ${body.last_name}`;
        body.email = email;
        delete body.first_name;
        delete body.last_name;
        delete body.agreeTOS;
        // confirm password is only client side, API doesnt expect confirmPassword field
        delete body.confirmPassword;
        //   Just necessary on the frontend side
        delete body.step;
        delete body.errors;
        delete body["g-recaptcha-response"];
        delete body.pushAccountInfo;
        try {
          const resp = await (
            await api("organization-register-coach", {
              method: "POST",
              body,
              files,
            })
          ).json();

          const { token, refreshToken, userId } = await (
            await api("login", {
              method: "POST",
              body,
              files,
            })
          ).json();

          const sessionOptions = { refresh: true, ttl: "1 day" };
          await login({ _id: userId, token, refreshToken }, sessionOptions);
          res.redirect(
            isPushAccountInfo
              ? "/coaching-portal/store"
              : "/coaching-portal/athletes"
          );
        } catch (e) {
          flash("error", e.message);
          return res.backDontScroll();
        }
      }
    );
};

export default SignupCoachOrganization;
